import React from "react";

function SkeletonField({ embedded = false }) {
  if (embedded) {
    return (
      <div className="cms-provider-add-field flex min-w-0 flex-col gap-1.5">
        <div className="h-4 w-24 animate-pulse rounded bg-gray-200" />
        <div className="h-10 w-full animate-pulse rounded-lg bg-gray-200" />
      </div>
    );
  }

  return (
    <div className="cms-provider-add-field">
      <div
        className="cms-providers-skeleton-bone"
        style={{ width: "40%", height: 12, marginBottom: 8 }}
      />
      <div
        className="cms-providers-skeleton-bone"
        style={{ width: "100%", height: 38 }}
      />
    </div>
  );
}

function CourseFormSkeleton({ embedded = false }) {
  const gridClass = embedded
    ? "grid w-full grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
    : "cms-provider-add-grid";
  const gridStyle = embedded
    ? undefined
    : {
        display: "grid",
        gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
        gap: "16px",
        width: "100%",
        alignItems: "start",
      };

  return (
    <div className={embedded ? "w-full" : "cms-provider-add-form"}>
      <div className={embedded ? "flex w-full flex-col gap-4" : "cms-provider-add-section"}>
        <div className={gridClass} style={gridStyle}>
          {[...Array(8)].map((_, index) => (
            <SkeletonField key={index} embedded={embedded} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default CourseFormSkeleton;
